import script from "./apply.vue?vue&type=script&setup=true&lang=js"
export * from "./apply.vue?vue&type=script&setup=true&lang=js"

import "./apply.vue?vue&type=style&index=0&id=3dd6648a&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd6648a"]])

export default __exports__